
import { API } from "aws-amplify";
import { Alert } from '../../types';

export async function updateAlert(alert: Alert) {
  const { monitorId, time, cleared } = alert;
  const body: any = {
    monitorId,
    time,
    cleared,
  }
  try {
    const res: any = await API.post("data", "/data/alerts", {
      body,
    });
    return res;
  } catch(e) {
    console.log(e)
  }
}





// WEBPACK FOOTER //
// ./src/utils/api/updateAlert.ts